var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEnvelopeOpenText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 10.5469H16.4062C16.8379 10.5469 17.1875 10.1973 17.1875 9.76562V8.98437C17.1875 8.55273 16.8379 8.20312 16.4062 8.20312H8.59375C8.16211 8.20312 7.8125 8.55273 7.8125 8.98437V9.76562C7.8125 10.1973 8.16211 10.5469 8.59375 10.5469ZM7.8125 14.4531C7.8125 14.8848 8.16211 15.2344 8.59375 15.2344H16.4062C16.8379 15.2344 17.1875 14.8848 17.1875 14.4531V13.6719C17.1875 13.2402 16.8379 12.8906 16.4062 12.8906H8.59375C8.16211 12.8906 7.8125 13.2402 7.8125 13.6719V14.4531ZM12.5 20.3677C11.6982 20.3677 10.8965 20.1206 10.2119 19.626L0 12.249V22.6562C0 23.9507 1.04932 25 2.34375 25H22.6562C23.9507 25 25 23.9507 25 22.6562V12.249L14.7881 19.626C14.1035 20.1201 13.3018 20.3677 12.5 20.3677ZM24.1021 7.95654C23.6699 7.61767 23.2603 7.29883 22.6562 6.84277V4.6875C22.6562 3.39306 21.6069 2.34375 20.3125 2.34375H16.5259C16.3774 2.23633 16.2393 2.13574 16.0845 2.02344C15.2637 1.42431 13.6328 -0.0170918 12.5 -1.93503e-06C11.3672 -0.0170918 9.73682 1.42431 8.91553 2.02344C8.76074 2.13574 8.62256 2.23633 8.47412 2.34375H4.6875C3.39307 2.34375 2.34375 3.39306 2.34375 4.6875V6.84277C1.73975 7.29834 1.33008 7.61767 0.897949 7.95654C0.618241 8.17574 0.392048 8.45569 0.236481 8.7752C0.0809144 9.09471 4.81351e-05 9.44541 0 9.80078L0 10.3208L4.6875 13.707V4.6875H20.3125V13.707L25 10.3208V9.80078C25 9.08105 24.6689 8.40088 24.1021 7.95654Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelopeOpenText);
export default __webpack_public_path__ + "static/media/icon-envelope-open-text.d0ec1d0bfa65f2a944c74c7125c2adac.svg";
export { ForwardRef as ReactComponent };